export const getTestId = (rootId?: string, elementId?: string) => {
  if (!rootId) {
    return;
  }

  if (!elementId) {
    return rootId;
  }

  return `${rootId}-${elementId}`;
};
